import { Card, PageHead } from '../components/ui';

/** bull-board из API (/admin/queues) — под той же админской сессией. */
export function Queues() {
  return (
    <>
      <PageHead
        title="Очереди"
        actions={
          <a href="/admin/queues" target="_blank" rel="noreferrer" className="inline-flex h-11 items-center rounded-xl border border-line-strong bg-field px-[18px] text-sm font-bold text-white">
            Открыть отдельно ↗
          </a>
        }
      />
      <Card className="overflow-hidden p-0">
        <iframe title="Очереди BullMQ" src="/admin/queues" className="block h-[calc(100dvh-220px)] min-h-[560px] w-full border-0 bg-white" />
      </Card>
      <span className="text-xs text-dim">photo — отправка кадров (платные вперёд, лимит kie.ai 20 задач / 10 с) · check — проверка статуса · sweep — крон раз в минуту.</span>
    </>
  );
}
